let result = {};
let regexParse = new RegExp('([a-z\-0-9]{2,63})\.([a-z\.]{2,5})$');
let urlParts = regexParse.exec(window.location.hostname);
result.domain = urlParts[1];
result.type = urlParts[2];
result.subdomain = window.location.hostname.replace(result.domain + '.' + result.type, '').slice(0, -1);
result.subdomain = result.subdomain == "localhos" ? "localhost" : result.subdomain;

let conf = {
  "*": {
    title: result.subdomain.charAt(0).toUpperCase() + result.subdomain.substring(1) + " Bestillingsportal | DEFA",
    logoUrl: "/assets/retailers/" + result.subdomain + ".png",
    showEdaLogo: false,
    admin: { name: "DEFA", }
  },
  "ham": {
    title: "Harald A. Møller Bestillingsportal | DEFA",
    showEdaLogo: false,
    admin: { name: "DEFA", }
  },
  "hedin": {

    title: "Hedin Bil Bestillingsportal | DEFA",
    showEdaLogo: false,
    admin: { name: "DEFA", }
  },
  "bos": {
    title: "Bertel O. Steen Bestillingsportal | DEFA"
  },

  "localhost": {
    //       title: "Lokal testportal | DEFA",
    showEdaLogo: false,
  }
}


export default conf.hasOwnProperty(result.subdomain) ? { ...conf["*"], ...conf[result.subdomain] } : conf["*"]



